import { PushInterface } from './interface/push-interface';

export class Push {
    investidorUuid: string;
    valor: number;
    rodadaUuid: string;
    termosServico: boolean;
    avisoRiscos: boolean;
    confirmacaoNomeInvestidor: string
    constructor (push: PushInterface) {
        this.investidorUuid = push.investidorUuid;
        this.valor = push.valor;
        this.rodadaUuid = push.rodadaUuid;
        this.termosServico = push.termosServico;
        this.avisoRiscos = push.avisoRiscos;
        this.confirmacaoNomeInvestidor = push.confirmacaoNomeInvestidor
    }
}